import { render } from "./MenuMobileDois.vue?vue&type=template&id=6ea885f4&scoped=true"
const script = {}

import "./MenuMobileDois.vue?vue&type=style&index=0&id=6ea885f4&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea885f4"]])

export default __exports__